import { h } from 'preact';
import { Icon } from '@cube/blocks';
import style from './style';
import cx from 'classnames';

export default function IconHeader({ icon, children, hidden, ...props }) {
	return (
		<div {...props} class={cx(style.header, hidden && style.hidden, props.class)}>
			{ icon && <Icon class={style.icon} name={icon} /> }
			{children}
		</div>
	);
}
